import { memo } from "react";
import { Modal, Button } from "antd";
import IntlMessages from "../Message/IntlMessages";
import { CustodianRegisterStatus } from "const";
import dayjs from "dayjs";
import { useIntl } from "react-intl";
import DangerousMessage from "components/Message/DangerousMessage";

const OffshoreInformPopups = ({ code, close, state, actions, ...modalProps }) => {
  const intl = useIntl();

  function _onAccept() {
    close();
    actions?.onAccept && actions.onAccept(code);
  }

  function _onCancel() {
    close();
    actions?.onCancel && actions.onCancel();
  }

  function getExpiredDate() {
    return state?.expiredDate ? dayjs(state.expiredDate).format("DD/MM/YYYY") : "";
  }

  function getMessage() {
    switch (state?.status) {
      case CustodianRegisterStatus.NORMAL.code:
      case CustodianRegisterStatus.REGISTER_SUCCESS.code: {
        return <IntlMessages id="custodian.popup.already-register" />;
      }
      case CustodianRegisterStatus.WAITING.code: {
        const rawMessage = intl.messages["custodian.popup.waiting-approval"] || "";
        const waitingApprovalHtml = String(rawMessage).replace("{expiredDate}", getExpiredDate());
        return <DangerousMessage.Div html={waitingApprovalHtml} />;
      }
      case CustodianRegisterStatus.EXPIRED.code: {
        return <IntlMessages id="custodian.popup.expired" />;
      }
      default:
        return null;
    }
  }

  return (
    <Modal {...modalProps}>
      {modalProps.visible && (
        <div className="mnc-modal-style-1">
          <div className="modal-mnc-head">
            <h5 className="m-0">
              <IntlMessages id="custodian.service.title" />
            </h5>
            <Button className="btn button-ktb-close" onClick={_onCancel}>
              <i className="feather-icon icon-x"></i>{" "}
            </Button>
          </div>
          <div className="modal-mnc-body color-primary-navy-blue kt-font-b">
            {getMessage()}
          </div>
          <div className="modal-mnc-footer">
            <div className="row justify-content-center">
              <div className="col-6 pe-1 pe-md-2">
                <div className="d-grid">
                  <Button data-cancel-btn className="btn button-ktb-line" onClick={_onCancel}>
                    <IntlMessages id="global.close" />
                  </Button>
                </div>
              </div>
              {state.status === CustodianRegisterStatus.EXPIRED.code && (
                <div className="col-6 ps-1 ps-md-2">
                  <div className="d-grid">
                    <Button data-accept-btn className="btn button-ktb-main" onClick={_onAccept}>
                      <IntlMessages id="global.ok" />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default memo(OffshoreInformPopups);
